document.addEventListener('DOMContentLoaded', () => {
  const policyButtons = document.querySelectorAll('.shipping-policy-trigger');
  const modal = document.getElementById('shipping-modal');
  const closeButton = modal ? modal.querySelector('.modal-close') : null;

  console.log('1111111111', policyButtons, modal);
  // 检查元素是否存在
  if (!policyButtons.length || !modal || !closeButton) {
    console.error('Modal elements not found');
    return;
  }

  // 打开弹窗
  policyButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      console.log('click11111')
      e.preventDefault();
      modal.classList.remove('hidden');
      button.setAttribute('aria-expanded', 'true');
    });
  });

  // 关闭弹窗
  closeButton.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  function closeModal() {
    modal.classList.add('hidden');
    policyButtons.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
  }
});